// import { message, notification } from "ant-design-vue";
// import moment from "moment";
import { COMMON } from "@/constants";

var utils = {
  // // 获取字符串的哈希编码
  // hashCode: text => {
  //   var hash = 0,
  //     char;
  //   if (text.length == 0) return hash;
  //   for (var i = 0; i < text.length; i++) {
  //     char = text.charCodeAt(i);
  //     hash = (hash << 5) - hash + char;
  //     hash = hash & hash;
  //   }
  //   return hash;
  // },
  // // 字符串str按照sep分割为数组，并清理掉数组结果中的空白项。
  // stringSplit: (str, sep) => {
  //   if (
  //     !str ||
  //     str.constructor !== String ||
  //     !sep ||
  //     sep.constructor !== String
  //   ) {
  //     return [];
  //   }
  //   let ary = str.split(sep);
  //   ary = ary.map(p => {
  //     return p.trim();
  //   });
  //   ary = ary.trim();
  //   return ary;
  // },
  // // 去除千分位
  // delcommafy(num) {
  //   //去除千分位中的‘，’
  //   if (num && num != "undefined" && num != "null") {
  //     let numS = num;
  //     numS = numS.toString();
  //     numS = numS.replace(/,/gi, "");
  //     return numS;
  //   } else {
  //     return num;
  //   }
  // },
  // // 部分编辑
  // partEdit(main, editItem) {
  //   for (const a in main) {
  //     main[a] = "r";
  //     if (editItem && editItem.length > 0) {
  //       editItem.forEach(e => {
  //         if (a == e) {
  //           main[a] = "w";
  //         }
  //       });
  //     }
  //   }
  //   return main;
  // },

  //数据格式化 两位小数
  dataTransform(val) {
    let res = "";
    let point = "";
    let symbol = false;
    let num = "";
    let str = "";
    if (typeof val == "undefined") {
      str = "";
    } else if (parseFloat(val) == 0) {
      str = "0.00";
    } else {
      val = parseFloat(val).toFixed(2);
      if (val.indexOf("-") > -1) {
        let arr = val.split("-");
        symbol = true;
        num = arr[1];
      } else {
        num = val;
      }
      if (num.indexOf(".") > -1) {
        let arr1 = num.split(".");
        res = arr1[0];
        point = arr1[1];
      } else {
        res = num;
      }
      let beforArr = res.split("").reverse();
      let afterArr = [];
      beforArr.forEach((item, index) => {
        if (index % 3 == 0 && index != 0) {
          afterArr.push(",");
        }
        afterArr.push(item);
      });
      afterArr = afterArr.reverse();

      afterArr.forEach(item => {
        str += item;
      });
      if (point != "") {
        str = str + "." + point;
      } else {
        str = str + ".00";
      }
      if (symbol == true) {
        str = "-" + str;
      }
    }
    return str;
  },
  // //项目状态转换
  // status(num) {
  //   let desc = "";
  //   const dataList = COMMON.PROJECT_STATUS;
  //   dataList.forEach(item => {
  //     if (num === item.key) {
  //       desc = item.value;
  //     }
  //   });
  //   return desc;
  // },
  // //错误信息翻译
  translateErrMsg(code) {
    let errMg = "";
    const dataList = COMMON.ERROR_MESSAGE;
    dataList.forEach(item => {
      if (code === item.code) {
        errMg = item.msg;
      }
    });
    return errMg;
  },
  // // 项目状态value转key
  // statusValueToKey(num) {
  //   let desc = "";
  //   const dataList = COMMON.PROJECT_STATUS;
  //   dataList.forEach(item => {
  //     if (num === item.value) {
  //       desc = item.key;
  //     }
  //   });
  //   return desc;
  // },
  // //根据传入的值和数组进行比较，相等返回该数据个某条数据
  // indexOfList(list, key, value) {
  //   for (let i = 0; i < list.length; i++) {
  //     if (list[i][key] == value) {
  //       return list[i];
  //     }
  //   }
  // },
  // //字节数转KB或者MB
  // bigDecimal: bytes => {
  //   let returnValue = bytes / (1024 * 1024);
  //   if (returnValue > 1) {
  //     return returnValue.toFixed(2) + "M";
  //   } else {
  //     returnValue = bytes / 1024;
  //     return returnValue.toFixed(0) + "KB";
  //   }
  // },
  // //获取指定字符后面所有字符
  // substringType: (str, type) => {
  //   let returnValue = str.split(".");
  //   return returnValue[returnValue.length - 1];
  // },
  // 获取随机的名称
  getName: () => {
    return Math.random()
      .toString(36)
      .substr(2);
  },
  // 获取控件是否可编辑
  // getWriteable: permission => {
  //   if (permission !== "r") {
  //     return true;
  //   }
  //   return false;
  // },
  // 获取控件是否添加必填校验
  addRequiredOrNot: (permission, validate, linkageValidate, _this) => {
    //判断是否有联动校验
    if (linkageValidate.length > 0) {
      linkageValidate.forEach(ele => {
        if (ele && ele.validate && "data." + ele.target == _this.atter) {
          validate = ele.validate;
        }
      });
    }
    if (permission !== "b") {
      return validate;
    }
    //如果表单授权为某控件加了必填则必填
    if (
      permission === "b" &&
      validate &&
      !validate.required &&
      validate.constructor === Object
    ) {
      validate.required = true;
    }
    if (validate === undefined || validate === null) {
      validate = "required";
    } else if (validate.constructor === String) {
      let ary = validate.split("|");
      if (!ary.some(item => item === "required")) {
        ary.splice(0, 0, "required");
        validate = ary.join("|");
      }
    } else if (validate.constructor === Object) {
      validate = Object.assign({ required: true }, validate);
    } else {
      throw "validate不是允许的类型";
    }
    return validate;
  },
  // 两个日期相差天数
  GetNumberOfDays(date1, date2) {
    //date1：开始日期，date2结束日期
    var a1 = Date.parse(new Date(date1));
    var a2 = Date.parse(new Date(date2));
    var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
    return day;
  },
  // 格式化日期
  formatDate: value => {
    let date = null;
    if (!value) {
      return date;
    }
    if (value.constructor == Date && !isNaN(value.getTime())) {
      date = value;
    } else if (value.constructor == String || value.constructor == Number) {
      date = new Date(value);
    } else {
      throw "格式化日期时，传入的数据格式不正确。";
    }
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? "0" + MM : MM;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let m = date.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
  },
  // 格式化日期
  formatDateYear: value => {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? "0" + MM : MM;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    return y + "-" + MM + "-" + d;
  },
  // 日期转为yyyy-MM格式
  formatDateMonth: value => {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? "0" + MM : MM;
    return y + "-" + MM;
  },
  // 某日和今天相差时间
  todayToTime(date) {
    //date1：开始日期，date2结束日期
    const a11 = Date.parse(new Date(date));
    const a22 = Date.parse(new Date());
    const day = parseInt((a11 - a22) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
    return day;
  },
  // 比较2个日期
  daysBetween: (DateOne, DateTwo, notSupportEquals) => {
    if (!DateOne || !DateTwo) {
      return true;
    }
    var date1 =
      new Date(DateOne).getTime() ||
      new Date(new Date().format("yyyy-MM-dd") + " " + DateOne).getTime();
    var date2 =
      new Date(DateTwo).getTime() ||
      new Date(new Date().format("yyyy-MM-dd") + " " + DateTwo).getTime();
    if (notSupportEquals) {
      //大于。v2>v1 。
      if (date2 > date1) {
        return true;
      } else {
        return false;
      }
    } else {
      //大于等于。v2>=v1 。只要v1不大于v2即可
      if (date1 > date2) {
        return false;
      } else {
        return true;
      }
    }
  },
  dateCalc: (startDate, endDate, op) => {
    if (
      !startDate ||
      !endDate ||
      startDate.length == 0 ||
      endDate.length == 0
    ) {
      return 0;
    }
    if (op.legend == 0) {
      op = "day";
    }
    var date1 =
      new Date(startDate).getTime() ||
      new Date(new Date().format("yyyy-MM-dd") + " " + startDate).getTime();
    var date2 =
      new Date(endDate).getTime() ||
      new Date(new Date().format("yyyy-MM-dd") + " " + endDate).getTime();
    var res = 0;
    var days = date2 - date1;
    switch (op) {
      case "year":
        res = parseInt(days / (1000 * 60 * 60 * 24 * 30 * 12));
        break;
      case "month":
        res = parseInt(days / (1000 * 60 * 60 * 24 * 30));
        break;
      case "day":
        res = parseInt(days / (1000 * 60 * 60 * 24));
        break;
      case "hour":
        res = parseInt(days / (1000 * 60 * 60));
        break;
      case "minute":
        res = parseInt(days / (1000 * 60));
        break;
      default:
        res = parseInt(days / 1000);
    }
    return res;
  },
  // 平铺结构转嵌套结构
  tile2nest: (array, key, pKey, childrenKey) => {
    if (!array || array.constructor !== Array) {
      return array;
    }
    // 复制一份，避免修改原始数组
    let ary = [...array];
    key = key || "id";
    pKey = pKey || "parentId";
    childrenKey = childrenKey || "children";
    // 定义一个待移除数组
    let ary2remove = [];
    ary.map(item => {
      if (item[key] !== item[pKey]) {
        // 找父节点
        let p = ary.filter(c => c[key] === item[pKey]);
        if (p && p.length == 1) {
          p[0].children = p[0].children || [];
          // 将子节点放到父节点中
          p[0].children.push(item);
          ary2remove.push(item[key]);
        }
      }
    });
    // 遍历移除待删除对象
    ary2remove.map(item => {
      ary = ary.filter(c => c[key] !== item);
    });
    return ary;
  },
  deepClone(obj) {
    if (obj) {
      let _obj = JSON.stringify(obj);
      return JSON.parse(_obj);
    } else {
      return {};
    }
  },
  // 从对象中获取和验证字段路径
  getAndValidPath: (obj, key) => {
    if (
      !obj ||
      obj.constructor != Object ||
      !key ||
      key.constructor != String
    ) {
      return null;
    }
    if (!obj.hasOwnProperty(key)) {
      return null;
    }
    let path = obj[key];
    if (/^\w+.*\w+$/.test(path)) {
      return path;
    } else {
      return null;
    }
  },
  // 获取Vue实例中指定className的父实例
  getParentInstanceByClassName: (instance, className) => {
    if (!instance) {
      throw "VueComponent实例为空.";
    }
    if (
      instance.$el.className &&
      instance.$el.className.indexOf(className) > -1
    ) {
      return instance;
    } else if (instance.$root && instance.$root._uid == instance._uid) {
      throw `查找VueComponent实例树时找到根节点都未找到className为${className}的实例.`;
    } else if (instance.$parent) {
      return utils.getParentInstanceByClassName(instance.$parent, className);
    }
  },
  // 获取控件所在表单对应的实例对象
  getOnlineFormInstance: instance => {
    if (!instance) {
      throw "VueComponent实例为空.";
    }
    if (
      instance.$el.getAttribute &&
      instance.$el.getAttribute("name") === "online-form"
    ) {
      return instance;
    } else if (instance.$root && instance.$root._uid == instance._uid) {
      throw `查找VueComponent实例树时找到根节点都未找到name为online-form的实例.`;
    } else if (instance.$parent) {
      return utils.getOnlineFormInstance(instance.$parent);
    }
  },

  // 获取Vue实例及父级实例中有reload方法的实例
  getReloadMethod: instance => {
    if (!instance) {
      return null;
    }
    if (instance.reload && instance.reload.constructor === Function) {
      return instance;
    } else if (instance.$root && instance.$root._uid == instance._uid) {
      return null;
    } else if (instance.$parent) {
      return utils.getReloadMethod(instance.$parent);
    }
  },

  // 重新加载当前页面(不会刷新整个页面，只刷新router-view部分)
  reload: () => {
    let viewElementAry = document.getElementsByName("app-base-main");
    if (!viewElementAry || viewElementAry.length != 1) {
      window.location.reload();
    } else {
      let viewInst = viewElementAry[0].__vue__;
      if (!viewInst || !viewInst._isVue) {
        window.location.reload();
      }
      let r = utils.getReloadMethod(viewInst);
      if (r) {
        r.reload();
      } else {
        window.location.reload();
      }
    }
  },
  // 获取在线表单的json格式字符串的表单数据(validate参数决定是否需要对表单进行验证)
  // getOnlineFormData: validate => {
  //   return new Promise((resolve, reject) => {
  //     let formElementAry = document.getElementsByName("online-form");
  //     if (!formElementAry || formElementAry.length != 1) {
  //       var frmFrame = $("#frmFrame");
  //       if (frmFrame && frmFrame.length > 0) {
  //         var frm = frmFrame[0];
  //         var isCallBack = false;
  //         var cancelTimeout = false;
  //         var isTimeOut = false;
  //         // 子页面是否收到了消息
  //         var isRoger = false;
  //         frm.contentWindow.postMessage("saveData", "*");
  //         window.addEventListener("message", function (e) {
  //           if (e.data && e.data.constructor == Object) {
  //             if (e.data.type == "saveData" && !isCallBack) {
  //               isCallBack = true;
  //               if (e.data.state && !isTimeOut) {
  //                 let iframeData = {
  //                   businessKey: e.data.businessKey,
  //                   sysCode: e.data.sysCode
  //                 };
  //                 if (e.data.vars) {
  //                   iframeData.vars = e.data.vars;
  //                 }
  //                 resolve(iframeData);
  //               }
  //             } else if (e.data.type == "cancelTimeout") {
  //               cancelTimeout = true;
  //             } else if (e.data.type == "roger" && !isRoger) {
  //               isRoger = true;
  //             }
  //           }
  //         });

  //         // 只要子页面引入了eco.helper.js，父页面发送了消息后，子页面会马上回复`roger`。
  //         // 这里设置0.5秒后未收到`roger`消息则认为子页面未引入eco.helper.js，此时直接reject。
  //         setTimeout(function () {
  //           if (!isRoger) {
  //             reject(6);
  //           }
  //         }, 500);

  //         // 设置10秒超时机制，如果超时则不再往下执行
  //         setTimeout(function () {
  //           if (!isCallBack && !cancelTimeout) {
  //             isTimeOut = true;
  //             reject(5);
  //           }
  //         }, 10000);
  //       } else {
  //         reject(1);
  //       }
  //     } else {
  //       let frmInst = formElementAry[0].__vue__;
  //       if (!frmInst || !frmInst._isVue) {
  //         reject(2);
  //       }
  //       frmInst.$root.$validator.validateAll("custom-form").then(result => {
  //         if (result) {
  //           resolve(JSON.stringify(frmInst.data));
  //         } else {
  //           if (validate) {
  //             reject({
  //               reason: 3,
  //               errors: frmInst.$root.$validator.errors.items
  //             });
  //           } else {
  //             resolve(JSON.stringify(frmInst.data));
  //           }
  //         }
  //       });
  //     }
  //   });
  // },
  // 获取表单数据失败的处理
  // handleGetFormDataReject: (reason, needConfirm) => {
  //   return new Promise((resolve, reject) => {
  //     let errors = [];
  //     if (reason && reason.constructor == Object) {
  //       errors = reason.errors;
  //       reason = reason.reason;
  //     }
  //     switch (reason) {
  //       case 1:
  //         Message.error("未获取到在线表单或者URL表单.");
  //         break;
  //       case 2:
  //         Message.error("使用了在线表单，但是表单为空或者加载失败.");
  //         break;
  //       case 3:
  //         let errorMsg = [];
  //         errors &&
  //           errors.forEach(e => {
  //             let fieldLabel = "";
  //             if (e.field) {
  //               if (e.field.indexOf("-") != -1) {
  //                 fieldLabel = e.field.substr(e.field.indexOf("-") + 1);
  //               } else {
  //                 fieldLabel = e.field;
  //               }
  //             }
  //             errorMsg.push(`${fieldLabel} ${e.msg}`);
  //           });
  //         if (errorMsg.length > 0) {
  //           Notification.error({
  //             title: "错误提示",
  //             dangerouslyUseHTMLString: true,
  //             message: `请正确的填写以下表单内容：<br/>${errorMsg.join(
  //               "<br/>"
  //             )}`
  //           });
  //         } else {
  //           Message.warning("请正确的填写表单内容.");
  //         }
  //         break;
  //       case 5:
  //         Message.error("URL表单处理业务数据超时.");
  //         break;
  //       case 6:
  //         if (needConfirm) {
  //           MessageBox.confirm(
  //             "URL表单页面未正确处理数据，是否仍然启动流程？",
  //             { type: "warning" }
  //           )
  //             .then(() => resolve())
  //             .catch(() => reject());
  //         } else {
  //           resolve();
  //         }
  //         break;
  //       default:
  //         Message.error(`获取表单数据时发生预期之外的异常，reason:${reason}`);
  //         break;
  //     }
  //   });
  // },
  // 获取指定dom元素的父级中具有指定属性的dom元素
  getParentElementByAttribute: (el, attribute) => {
    if (!el || !el.hasAttribute || el.hasAttribute.constructor !== Function) {
      throw "传入的元素el不能为空且必须为HTMLHtmlElement类型.";
    }
    if (!attribute || attribute.constructor !== String) {
      throw "传入的属性attribute不能为空且必须为String类型.";
    }
    if (el.hasAttribute(attribute)) {
      return el;
    } else if (el.tagName === "HTML") {
      return null;
    } else {
      return utils.getParentElementByAttribute(el.parentElement, attribute);
    }
  },
  // 从父级dom元素中获取指定属性的值
  getSomeAttributeFromParentElement: (el, attribute) => {
    let pEl = utils.getParentElementByAttribute(el, attribute);
    if (pEl && pEl.getAttribute && pEl.getAttribute.constructor === Function) {
      return pEl.getAttribute(attribute);
    }
    return null;
  },
  // 通过路径取得对象中的属性
  getValueByPath: (obj, path, subIndex) => {
    if (!obj || !path || path.constructor != String) {
      return null;
    }
    if (!/^\w?.*[\w|\]]$/.test(path)) {
      return null;
    }
    let pathAry = path.split(".");
    if (pathAry.length == 1) {
      return obj[path];
    } else if (pathAry.length > 1) {
      let ret = obj;
      for (var i = 0; i < pathAry.length; i++) {
        const key = pathAry[i];
        const match = /^(\w+)\[(\d+)\]$/.exec(key);
        if (match) {
          ret = ret[match[1]][match[2]];
        } else if (ret && ret.constructor === Array) {
          let index = 0;
          if (subIndex != null && subIndex != undefined) {
            let preIndex = Number.parseInt(subIndex);
            if (!isNaN(preIndex)) {
              index = preIndex;
            }
          }
          ret = ret[index][key];
        } else {
          ret = ret[key];
        }
      }
      return ret;
    }
    return null;
  },
  // 通过路径设置对象中的属性
  setValueByPath: (obj, path, value, subIndex) => {
    if (!obj || !path || path.constructor != String) {
      return;
    }
    if (!/^\w?.*[\w|\]]$/.test(path)) {
      return;
    }
    let pathAry = path.split(".");
    if (pathAry.length == 1) {
      obj[path] = value;
    } else if (pathAry.length > 1) {
      let ret = obj;
      for (var i = 0; i < pathAry.length; i++) {
        const key = pathAry[i];
        const match = /^(\w+)\[(\d+)\]$/.exec(key);
        if (i == pathAry.length - 1) {
          if (match) {
            ret[match[1]][match[2]] = value;
          } else if (ret && ret.constructor === Array) {
            let index = 0;
            if (subIndex != null && subIndex != undefined) {
              let preIndex = Number.parseInt(subIndex);
              if (!isNaN(preIndex)) {
                index = preIndex;
              }
            }
            ret[index][key] = value;
          } else {
            ret[key] = value;
          }
        } else {
          if (match) {
            ret = ret[match[1]][match[2]];
          } else {
            ret = ret[key];
          }
        }
      }
    }
  },
  /**
   * 将字符串转为json对象。
   * @param jsonStr
   * @param type  可不填写parseToJson
   * @return
   */
  parseToJson: (jsonStr, type) => {
    type = type || 1;
    if (!jsonStr || jsonStr === "") return;
    try {
      switch (type) {
        case 1:
          return eval("(" + jsonStr + ")");
          break;
        case 4:
          JSON.parse(jsonStr);
          break;
        default:
          throw "解析json对象错误";
          break;
      }
    } catch (e) {
      return parseToJson(jsonStr, type + 1);
    }
  },
  /**
   * 将数字转换成人名币大写。
   *
   * @param currencyDigits
   * @returns
   */
  convertCurrency: currencyDigits => {
    var MAXIMUM_NUMBER = 99999999999.99;
    var CN_ZERO = "零";
    var CN_ONE = "壹";
    var CN_TWO = "贰";
    var CN_THREE = "叁";
    var CN_FOUR = "肆";
    var CN_FIVE = "伍";
    var CN_SIX = "陆";
    var CN_SEVEN = "柒";
    var CN_EIGHT = "捌";
    var CN_NINE = "玖";
    var CN_TEN = "拾";
    var CN_HUNDRED = "佰";
    var CN_THOUSAND = "仟";
    var CN_TEN_THOUSAND = "万";
    var CN_HUNDRED_MILLION = "亿";
    var CN_SYMBOL = "";
    var CN_DOLLAR = "元";
    var CN_TEN_CENT = "角";
    var CN_CENT = "分";
    var CN_INTEGER = "整";
    var integral;
    var decimal;
    var outputCharacters;
    var parts;
    var digits, radices, bigRadices, decimals;
    var zeroCount;
    var i, p, d;
    var quotient, modulus;
    currencyDigits = currencyDigits.toString();
    if (currencyDigits == "") {
      return "";
    }
    if (currencyDigits.match(/[^,.\d]/) != null) {
      return "";
    }
    if (
      currencyDigits.match(
        /^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/
      ) == null
    ) {
      return "";
    }
    currencyDigits = currencyDigits.replace(/,/g, "");
    currencyDigits = currencyDigits.replace(/^0+/, "");

    if (Number(currencyDigits) > MAXIMUM_NUMBER) {
      return "";
    }

    parts = currencyDigits.split(".");
    if (parts.length > 1) {
      integral = parts[0];
      decimal = parts[1];

      decimal = decimal.substr(0, 2);
    } else {
      integral = parts[0];
      decimal = "";
    }

    digits = new Array(
      CN_ZERO,
      CN_ONE,
      CN_TWO,
      CN_THREE,
      CN_FOUR,
      CN_FIVE,
      CN_SIX,
      CN_SEVEN,
      CN_EIGHT,
      CN_NINE
    );
    radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
    bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
    decimals = new Array(CN_TEN_CENT, CN_CENT);

    outputCharacters = "";

    if (Number(integral) > 0) {
      zeroCount = 0;
      for (i = 0; i < integral.length; i++) {
        p = integral.length - i - 1;
        d = integral.substr(i, 1);
        quotient = p / 4;
        modulus = p % 4;
        if (d == "0") {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            outputCharacters += digits[0];
          }
          zeroCount = 0;
          outputCharacters += digits[Number(d)] + radices[modulus];
        }
        if (modulus == 0 && zeroCount < 4) {
          outputCharacters += bigRadices[quotient];
        }
      }
      outputCharacters += CN_DOLLAR;
    }

    if (decimal != "") {
      for (i = 0; i < decimal.length; i++) {
        d = decimal.substr(i, 1);
        if (d != "0") {
          outputCharacters += digits[Number(d)] + decimals[i];
        }
      }
    }

    if (outputCharacters == "") {
      outputCharacters = CN_ZERO + CN_DOLLAR;
    }
    if (decimal == "") {
      outputCharacters += CN_INTEGER;
    }
    outputCharacters = CN_SYMBOL + outputCharacters;
    return outputCharacters;
  },
  /**
   * 数字格式转换成千分位
   *@param{Object}num
   */
  thousandBit: num => {
    if ((num + "").trim() == "") {
      return "";
    }
    if (isNaN(num)) {
      return "";
    }
    num = num + "";
    if (/^.*\..*$/.test(num)) {
      var pointIndex = num.lastIndexOf(".");
      var intPart = num.substring(0, pointIndex);
      var pointPart = num.substring(pointIndex + 1, num.length);
      intPart = intPart + "";
      var re = /(-?\d+)(\d{3})/;
      while (re.test(intPart)) {
        intPart = intPart.replace(re, "$1,$2");
      }
      num = intPart + "." + pointPart;
    } else {
      num = num + "";
      var re = /(-?\d+)(\d{3})/;
      while (re.test(num)) {
        num = num.replace(re, "$1,$2");
      }
    }
    return num;
  },
  /**
   * 通过name获取页面url地址参数
   * @param name
   * @returns
   *
   */
  getUrlKey: function(name) {
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.href
        ) || [, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
  }, //选择器上下移
  down: function(ary, selectArr, this_) {
    if (ary.length > 0 && selectArr.length > 0) {
      var idx = selectArr.indexOf(ary[ary.length - 1]);
      if (idx + 1 < selectArr.length) {
        var t = selectArr[idx + 1];
        selectArr[idx + 1] = selectArr[idx];
        selectArr[idx] = t;
        this_.calacInputSuffixHeight();
        this_.syncInputValue();
      }
    }
  },
  up: function(ary, selectArr, this_) {
    if (ary.length > 0 && selectArr.length > 0) {
      var idx = selectArr.indexOf(ary[ary.length - 1]);
      if (idx != 0) {
        var t = selectArr[idx - 1];
        selectArr[idx - 1] = selectArr[idx];
        selectArr[idx] = t;
        this_.calacInputSuffixHeight();
        this_.syncInputValue();
      }
    }
  },
  Array: {
    //上移按钮
    up: function(idx, list) {
      idx = parseInt(idx);
      if (idx < 1) {
        return;
      }
      var t = list[idx - 1];
      list[idx - 1] = list[idx];
      list[idx] = t;
    },
    //下移按钮
    down: function(idx, list) {
      idx = parseInt(idx);
      if (idx >= list.length - 1) {
        return;
      }
      var t = list[idx + 1];
      list[idx + 1] = list[idx];
      list[idx] = t;
    },
    resumeSn: function(list) {
      for (var k = 0; k < list.length; k++) {
        list[k].sn = k;
      }
      return list;
    },
    /**
     * idx 原位置
     * num 目标位置
     * list 数组
     */
    moveToNum: function(idx, target, list) {
      if (target == -1) {
        target = 0;
      } else if (idx >= target) {
        target = target + 1;
      }
      var t = list.splice(idx, 1);
      list.insert(target, t[0]);
      this.resumeSn(list);
    },
    //删除按钮
    del: function(idx, list) {
      list.splice(idx, 1);
    },
    //找到指定元素的未知
    idxOf: function(val, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i] == val) return i;
      }
      return -1;
    },
    //删除指定元素
    remove: function(val, list) {
      var idx = this.idxOf(val, list);
      if (idx > -1) {
        list.splice(idx, 1);
      }
    },
    //置顶
    top: function(idx, list) {
      if (idx >= list.length || idx < 1) {
        return;
      }
      //逐个交换
      for (var i = 0; i < idx; i++) {
        var temp = list[i];
        list[i] = list[idx];
        list[idx] = temp;
      }
    },
    //置底
    bottom: function(idx, list) {
      if (idx >= list.length - 1 || idx < 0) {
        return;
      }
      //逐个交换
      for (var i = list.length - 1; i > idx; i--) {
        var temp = list[i];
        list[i] = list[idx];
        list[idx] = temp;
      }
    }
  },
  /**
   * 对象转url参数
   * @param {*} data
   * @param {*} isPrefix
   */
  queryParams(data, isPrefix = false) {
    let prefix = isPrefix ? "?" : "";
    let _result = [];
    for (let key in data) {
      let value = data[key];
      // 去掉为空的参数
      if (["", undefined, null].includes(value)) {
        continue;
      }
      if (value.constructor === Array) {
        value.forEach(_value => {
          _result.push(
            encodeURIComponent(key) + "[]=" + encodeURIComponent(_value)
          );
        });
      } else {
        _result.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
      }
    }

    return _result.length ? prefix + _result.join("&") : "";
  },

  /**
   * 数据字典查找
   * @param key value值
   * @param typeKey type
   * @param allData 所有的数据
   */
  findAllDataDict: (key, typeKey, allData) => {
    const index = allData.find(item => typeKey == item.key);
    if (index) {
      const indexChild = index.children.find(itemChild => key == itemChild.key);
      if (indexChild) {
        return indexChild.name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  },
  /**
   * 判断是否为空
   */
  isEmpty(obj) {
    return typeof obj === 'undefined' || obj == null || obj === '' || JSON.stringify(obj) == '{}'
  },
  /**
   * 枚举查找
   * @param data value值
   */
  getAllEnumerateAttr(data) {
    const { typeKey, isShowList, innerKey, showEmpty, showDetail, allData} = data;
    let temp = allData.find((item) => item.name === typeKey).attrs;
    if (temp) {
      if (isShowList) {
        return temp;
      } else {
        // 判断key是否存在逗号
        if (this.isEmpty(innerKey)) return "";
        const innerKeyTran = innerKey.toString();
        let hasKey = innerKeyTran.indexOf(",");
        if (hasKey > -1) {
          let keySplit = innerKeyTran.split(",");
          let desc = keySplit.map(items => {
            const transTemp = temp.find(
              itemChild => itemChild.value === items.toString()
            );
            if (transTemp) {
              return transTemp.label;
            } else {
              if (showEmpty) return "-";
              if (showDetail === "1") return innerKeyTran;
              return `${items}(已删除)`;
            }
          });
          return desc.join(",");
        } else {
          const transTemp = temp.find(
            itemChild => itemChild.value === innerKeyTran
          );
          if (transTemp) {
            return transTemp.label;
          } else {
            if (showEmpty) return "-";
            if (showDetail === "1") return innerKeyTran;
            return `${innerKeyTran}(已删除)`;
          }
        }
      }
    } else {
      return [];
    }
  },
  findDictList: (typeKey, allData) => {
    const index = allData.find(item => typeKey == item.key);
    if (index) {
      return index.children;
    } else {
      return [];
    }
  },
  findDictLeafList: (typeKey, allData) => {
    const index = allData.find(item => typeKey == item.key);
    if (index) {
      return utils.tile2nest(index.children);
    } else {
      return [];
    }
  },
  Menu: {
    addSubMenus: function(that, children) {
      let this_ = this;
      if (children && children.length > 0) {
        //					if(!parent.children){
        //						parent.children = [{path:'/', redirect:children[0].menuUrl}];
        //					}
        children.forEach(m => {
          //const route = {path: m.menuUrl, name: m.alias,  component: resolve => require([`@/${m.templateUrl}`], resolve )};
          //parent.children.push(route);
          if (m.children && m.children.length > 0) {
            this_.addSubMenus(that, m.children);
          }
        });
      }
    },
    addToRouter: function(that, route) {
      let routes = that.$router.options.routes;
      let isIn = false;
      routes.forEach(r => {
        if (r.path == route.path) {
          isIn = true;
        }
      });
      if (!isIn) {
        that.$router.options.routes.push(route);
        that.$router.addRoutes([route]);
      }
    },
    addSyncMenus: function(that, menus) {
      if (menus && menus.constructor === Array && menus.length > 0) {
        // 更新当前选中的菜单
        setTimeout(() => {
          const curRoutePath = that.$route.path;
          menus.forEach(m => {
            //将动态菜单添加到路由
            if (
              m.code != "home" &&
              m.code != "statement" &&
              that.menuMaps[m.code]
            ) {
              //const route = {path: m.path,  component: resolve => require([`@/${m.templateUrl}`], resolve )};
              //添加路由信息
              if (that.menuMaps[m.code] && that.menuMaps[m.code].length > 0) {
                this.addSubMenus(that, that.menuMaps[m.code]);
              }
              // this.addToRouter(that,route);
            }
            const p = new RegExp(`^/${m.alias}/.*$`);
            if (p.test(curRoutePath)) {
              that.activeMenuIndex = m.alias;
            }
          });
        }, 100);
      }
    }
  },
  //营销项目状态装换
  changeMarketingStatus: status => {
    if (status === "track" || status === 1) {
      return "营销跟踪";
    } else if (status === "bidding" || status === 2) {
      return "投标阶段";
    } else if (status === "win_bid" || status === 3) {
      return "已中标";
    } else if (status === "failed_bid" || status === 4) {
      return "未中标";
    } else if (status === "construction_approval" || status === 5) {
      return "已施工立项";
    } else if (status === "design_approval" || status === 6) {
      return "已设计立项";
    } else if (status === "marketing_give_up" || status === -1) {
      return "营销放弃";
    }
  },
  _mime (option, value) {
    let mimeTypes = navigator.mimeTypes
    for (let mt in mimeTypes) {
      if (mimeTypes[mt][option] === value) {
        return true
      }
    }
    return false
  },
  GetCurrentBrowser () {
    let ua = navigator.userAgent.toLocaleLowerCase()
    let browserType = null
    if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
      browserType = 'IE'
    } else if (ua.match(/firefox/) != null) {
      browserType = 'firefox'
    } else if (ua.match(/ucbrowser/) != null) {
      browserType = 'UC'
    } else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
      browserType = 'opera'
    } else if (ua.match(/bidubrowser/) != null) {
      browserType = 'baidu'
    } else if (ua.match(/metasr/) != null) {
      browserType = 'sougou'
    } else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
      browserType = 'QQ'
    } else if (ua.match(/maxthon/) != null) {
      browserType = 'maxthon'
    } else if (ua.match(/chrome/) != null) {
      var is360 = this._mime('type', 'application/vnd.chromium.remoting-viewer')
      if (is360) {
        browserType = '360'
      } else {
        browserType = 'chrome'
      }
    } else if (ua.match(/safari/) != null) {
      browserType = 'Safari'
    } else {
      browserType = 'others'
    }
    return browserType
  },
  GetOs () {
    let sUserAgent = navigator.userAgent.toLocaleLowerCase()
    let isWin = (navigator.platform.toLocaleLowerCase() === 'win32') || (navigator.platform.toLocaleLowerCase() === 'windows')
    let isMac = (navigator.platform.toLocaleLowerCase() === 'mac68k') || (navigator.platform.toLocaleLowerCase() === 'macppc') || (navigator.platform.toLocaleLowerCase() === 'macintosh') || (navigator.platform.toLocaleLowerCase() === 'macintel')
    if (isMac) return 'Mac'
    var isUnix = (navigator.platform === 'x11') && !isWin && !isMac
    if (isUnix) return 'Unix'
    var isLinux = (String(navigator.platform).indexOf('linux') > -1)
    if (isLinux) return 'Linux'
    if (isWin) {
      var isWin2K = sUserAgent.indexOf('windows nt 5.0') > -1 || sUserAgent.indexOf('windows 2000') > -1
      if (isWin2K) return 'Win2000'
      var isWinXP = sUserAgent.indexOf('windows nt 5.1') > -1 || sUserAgent.indexOf('windows xp') > -1
      if (isWinXP) return 'WinXP'
      var isWin2003 = sUserAgent.indexOf('windows nt 5.2') > -1 || sUserAgent.indexOf('windows 2003') > -1
      if (isWin2003) return 'Win2003'
      var isWinVista = sUserAgent.indexOf('windows nt 6.0') > -1 || sUserAgent.indexOf('windows vista') > -1
      if (isWinVista) return 'WinVista'
      var isWin7 = sUserAgent.indexOf('windows nt 6.1') > -1 || sUserAgent.indexOf('windows 7') > -1
      if (isWin7) return 'Win7'
    }
    if (sUserAgent.indexOf('android') > -1) return 'Android'
    if (sUserAgent.indexOf('iphone') > -1) return 'iPhone'
    if (sUserAgent.indexOf('symbianos') > -1) return 'SymbianOS'
    if (sUserAgent.indexOf('windows phone') > -1) return 'Windows Phone'
    if (sUserAgent.indexOf('ipad') > -1) return 'iPad'
    if (sUserAgent.indexOf('ipod') > -1) return 'iPod'
    return 'others'
  }
};

// 在数组上扩展一个删除指定项的方法
Array.prototype.remove = function(item) {
  this.splice(
    this.findIndex(v => v === item),
    1
  );
};

// 在数组上扩展一个去重的方法
Array.prototype.unique = function(arg) {
  const res = new Map();
  return this.filter(m => {
    if (arg) {
      return !res.has(m[arg]) && res.set(m[arg], 1);
    } else {
      return !res.has(m) && res.set(m, 1);
    }
  });
};

export default utils;

// 任务项目拷过来的方法
// export const relativelyTime = (value, now) => {
//   if (!now) {
//     now = moment();
//   }
//   const diff = moment(now).diff(moment(value), "hours");
//   if (diff <= 1) {
//     return moment(value).fromNow();
//   }
//   const today = moment(now).get("date");
//   const current = moment(value).get("date");
//   if (current < today - 1) {
//     // return moment(value).format('M月D日 H:mm');
//   }
//   let detailTime = moment(value).format("H:mm");
//   const currentDate = moment(value).format("YYYY-MM-DD");
//   const currentMonday = moment()
//     .weekday(0)
//     .format("YYYY-MM-DD");
//   const currentSunday = moment()
//     .weekday(6)
//     .format("YYYY-MM-DD");
//   let weekDate = "";
//   if (currentDate < currentMonday) {
//     weekDate = "[上周]dd " + detailTime;
//   } else if (currentDate > currentSunday) {
//     weekDate = "[下周]dd " + detailTime;
//   } else {
//     weekDate = "[周]dd " + detailTime;
//   }
//   return moment(value).calendar(null, {
//     sameDay: "[今天 ]" + moment(value).format("H:mm"),
//     nextDay: "[明天 ]" + detailTime,
//     nextWeek: weekDate,
//     lastDay: "[昨天 ]" + detailTime,
//     lastWeek: weekDate,
//     sameElse: "M月D日 H:mm"
//   });
// };

// export const relativelyTaskTime = (value, showDetailTime = false) => {
//   let detailTime = moment(value).format("H:mm");
//   if (!showDetailTime) {
//     detailTime = "";
//   }
//   const currentDate = moment(value).format("YYYY-MM-DD");
//   const currentMonday = moment()
//     .weekday(0)
//     .format("YYYY-MM-DD");
//   const currentSunday = moment()
//     .weekday(6)
//     .format("YYYY-MM-DD");
//   let weekDate = "";
//   if (currentDate < currentMonday) {
//     weekDate = "[上周]dd " + detailTime;
//   } else if (currentDate > currentSunday) {
//     weekDate = "[下周]dd " + detailTime;
//   } else {
//     weekDate = "[周]dd " + detailTime;
//   }
//   return moment(value).calendar(null, {
//     sameDay: "[今天 ]" + moment(value).format("H:mm"),
//     nextDay: "[明天 ]" + detailTime,
//     nextWeek: weekDate,
//     lastDay: "[昨天 ]" + detailTime,
//     lastWeek: weekDate,
//     sameElse: "M月D日 H:mm"
//   });
// };

// export const formatTaskTime = (begin, end) => {
//   //如果不是今天则不显示具体时间
//   if (!end && begin) {
//     return relativelyTaskTime(begin) + " 开始";
//   }
//   if (!begin) {
//     return relativelyTaskTime(end) + " 截止";
//   }
//   return relativelyTaskTime(begin) + " - " + relativelyTaskTime(end);
// };

// export const showHelloTime = time => {
//   let time_format = "";
//   if (time == undefined) {
//     time = new Date();
//   }
//   let hr = time.getHours();
//   if (hr >= 0 && hr <= 4) time_format = "深夜了，注意身体，";
//   if (hr >= 4 && hr < 7) time_format = "清晨好， ";
//   if (hr >= 7 && hr < 12) time_format = "早安，";
//   if (hr >= 12 && hr <= 13) time_format = "午饭时间到了，";
//   if (hr >= 13 && hr <= 17) time_format = "下午好，";
//   if (hr >= 17 && hr <= 18) time_format = "进入傍晚了，";
//   if (hr >= 18 && hr <= 20) time_format = "吃过晚饭了吗，";
//   if (hr >= 20 && hr <= 24) time_format = "在加班吗？辛苦了，";
//   return time_format;
// };

// export const checkResponse = (res, show_msg = false) => {
//   const code = res.state;
//   const msg = res.message;
//   if (!code) {
//     if (show_msg) {
//       notice(msg);
//     }
//     return false;
//   } else {
//     return true;
//   }
// };

// export const notice = (
//   content,
//   type = "message",
//   action = "warning",
//   duration = 3,
//   placement = "bottomLeft"
// ) => {
//   destroyNotice();
//   let config = {};
//   config.duration = duration;
//   if (type === "message") {
//     switch (action) {
//       case "info":
//         return message.info(content, duration);
//       case "success":
//         return message.success(content, duration);
//       case "error":
//         return message.error(content, duration);
//       case "loading":
//         return message.loading(content, duration);
//       default:
//         return message.warning(content, duration);
//     }
//   } else {
//     config.message = content.title;
//     config.description = content.msg || "";
//     config.placement = placement;
//     switch (action) {
//       case "open":
//         return notification.open(config);
//       case "info":
//         return notification.info(config);
//       case "success":
//         return notification.success(config);
//       case "error":
//         return notification.error(config);
//       default:
//         return notification.warning(config);
//     }
//   }
// };
// export const destroyNotice = (type = "") => {
//   if (!type) {
//     message.destroy();
//     notification.destroy();
//   } else {
//     type === "message" ? message.destroy() : notification.destroy();
//   }
// };
